module.exports = __webpack_public_path__ + "img/Foto_Yipi.361362e1.png";